const defaultProps = {
  includeBothMessages: true
};
const LumaFormHelperText = {
  defaultProps
};
export default LumaFormHelperText;